import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "7",
  height: "14",
  viewBox: "0 0 7 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Vector",
      d: "M1.6875 13L5.31201 7L1.6875 1",
      stroke: "#1C1D1F",
      "stroke-width": "2.25",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }